import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { QueryWrapper } from "./query";
import { UI } from "./ui";

const root = document.querySelector<HTMLElement>("#root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryWrapper>
        <UI />
      </QueryWrapper>{" "}
    </StrictMode>
  );
}
